import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-708a1ac2")

_pushScopeId("data-v-708a1ac2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("清空")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EfficiencyTrend = _resolveComponent("EfficiencyTrend")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, { style: {"overflow":"visible"} }, {
            default: _withId(() => [
              _withDirectives(_createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  (_ctx.project == 12)
                    ? (_openBlock(), _createBlock(_component_EfficiencyTrend, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini",
                    class: "spacForm"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "时间范围" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.datePick,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.datePick = $event)),
                            type: "datetimerange",
                            "range-separator": "To",
                            "default-time": _ctx.defaultTime1,
                            "start-placeholder": "Start date",
                            "end-placeholder": "End date"
                          }, null, 8, ["modelValue", "default-time"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        style: {"width":"500px"},
                        label: "搜索"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.serch_input,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.serch_input = $event)),
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch(true))),
                            "prefix-icon": "el-icon-search",
                            size: "mini"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch('Search')))
                          }, {
                            default: _withId(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "info",
                            onClick: _ctx.onClear
                          }, {
                            default: _withId(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table, {
                    size: "small",
                    class: "smoke_cursor",
                    data: _ctx.get_data.results,
                    "header-cell-class-name": "tabelHeader",
                    onRowClick: _ctx.handleDetail
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "date",
                        label: "测试时间"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.date), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "pkg_name",
                        label: "测试包"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.pkg_name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "readable_status",
                        align: "center",
                        label: "测试结果"
                      }, {
                        default: _withId((scope) => [
                          _createVNode("span", {
                            style: 
                    'color:' +
                    (scope.row.result === true ? '#00b050' : 'red') +
                    ' ;cursor: pointer;'
                  
                          }, _toDisplayString(scope.row.result === true ? "成功" : "失败"), 5)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "说明" }, {
                        default: _withId((scope) => [
                          _createVNode("span", null, _toDisplayString(scope.row.desc), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "备注" }, {
                        default: _withId((scope) => [
                          (scope.row.check)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (scope.row.check = !scope.row.check)
                              }, _toDisplayString(scope.row.remark ? scope.row.remark : "-"), 9, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_el_input, {
                                key: 1,
                                onKeyup: _withKeys(($event: any) => (_ctx.handleEvent(scope.row)), ["enter"]),
                                onBlur: ($event: any) => (_ctx.handleEvent(scope.row)),
                                size: "mini",
                                modelValue: scope.row.remark,
                                "onUpdate:modelValue": ($event: any) => (scope.row.remark = $event)
                              }, null, 8, ["onKeyup", "onBlur", "modelValue", "onUpdate:modelValue"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "onRowClick"]),
                  _createVNode(_component_el_footer, { class: "footerStyle" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, {
                            style: {"margin-bottom":"0"},
                            label: "每页"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.record,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.record = $event)),
                                style: {"width":"50px"},
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSearch('paging')))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            style: {"margin-bottom":"0"},
                            label: "条记录"
                          }),
                          _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                            default: _withId(() => [
                              _createVNode(_component_el_pagination, {
                                onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSearch('paging'))),
                                currentPage: _ctx.currentPage1,
                                "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentPage1 = $event)),
                                "page-size": _ctx.record,
                                layout: "total, prev, pager, next, jumper",
                                total: _ctx.get_data.count
                              }, null, 8, ["currentPage", "page-size", "total"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})